import { defineMessages } from 'react-intl';

export default defineMessages({
    Accounts: {
        id: 'ml.common.component.MLDownPaymentComponent.Accounts',
        defaultMessage: 'Accounts'
    },
    Actions: {
        id: 'ml.common.component.MLDownPaymentComponent.Actions',
        defaultMessage: 'Actions'
    },
    Edit: {
        id: 'ml.common.component.MLDownPaymentComponent.Edit',
        defaultMessage: 'Edit'
    },
    Remove: {
        id: 'ml.common.component.MLDownPaymentComponent.Remove',
        defaultMessage: 'Remove'
    },
    InstrumentOptionName: {
        id: 'ml.common.component.MLDownPaymentComponent.x - ending in x',
        defaultMessage: '{nickname} - ending in {last4Digits}'
    },
    AddAccount: {
        id: 'ml.common.component.MLDownPaymentComponent.ADD ACCOUNT',
        defaultMessage: 'ADD ACCOUNT'
    },
    DownpaymentRequired: {
        id: 'ml.common.component.MLDownPaymentComponent.A down payment of',
        defaultMessage: 'A down payment of {amount} is required for you to proceed'
    },
    YouWillReceiveInstrutions: {
        id: 'ml.common.component.MLDownPaymentComponent.You will receive instructions for making your payment by check',
        defaultMessage: 'You will receive instructions for making your payment by check.'
    },
    WhatPaymentMethod: {
        id: 'ml.common.component.MLDownPaymentComponent.What payment method do you want to use for the down payment',
        defaultMessage: 'What payment method do you want to use for the down payment?'
    },
    HowIsPaymentBeingMade: {
        id: 'ml.common.component.MLDownPaymentComponent.How is Payment being made',
        defaultMessage: 'How is Payment being made?'
    },
    InPerson: {
        id: 'ml.common.component.MLDownPaymentComponent.In Person',
        defaultMessage: 'In Person'
    },
    OverPhone: {
        id: 'ml.common.component.MLDownPaymentComponent.Over Phone',
        defaultMessage: 'Over Phone'
    },
    AgencySweep: {
        id: 'ml.common.component.MLDownPaymentComponent.Agency Sweep',
        defaultMessage: 'Agency Sweep'
    },
    CreditCardNotListed: {
        id: 'ml.common.component.MLDownPaymentComponent.A credit card is not listed on file.  To add, select ADD ACCOUNT.',
        defaultMessage: 'A credit card is not listed on file.  To add, select ADD ACCOUNT.'
    },
    BankAccountNotListed: {
        id: 'ml.common.component.MLDownPaymentComponent.A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.',
        defaultMessage: 'A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.'
    },
    preferredPaymentMethodErrorMessage: {
        id:'ml.common.component.MLDownPaymentComponent.We are unable to set up the Down Payment option',
        defaultMessage: 'We are unable to process a credit card payment at this time since the Preferred Payment Method was selected and this discount is being applied. Please select a different payment method to use for the payment or update the Preferred Payment Method question in the Payment Frequency section.'
    }
});
